'use client';

import { useEffect } from 'react';
import { mergeClasses } from 'minimal-shared/utils';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import { newSearchParams } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';
import { useSearchParams } from 'src/routes/hooks';
import { CONFIG } from 'src/global-config';
import { useTranslate } from 'src/locales';
import { logoClasses, useLogoStore } from './';

// ----------------------------------------------------------------------

export function Logo({
  dinamic,
  disabled,
  isFull,
  className,
  sx,
  ...other
}) {
  const searchParams = useSearchParams();
  const {
    currentLang
  } = useTranslate();
  const {
    photoURL,
    resetPhotoURL
  } = useLogoStore();
  useEffect(() => {
    if (!searchParams.get('sellerID')) resetPhotoURL();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);
  return <Box aria-label="Logo" component={RouterLink} className={mergeClasses([logoClasses.root, className])} href={`/${newSearchParams({
    country: currentLang.countryName
  })}`} sx={[theme => ({
    height: 32,
    fontSize: 20,
    fontWeight: 'bold',
    textDecoration: 'none',
    ...(isFull && {
      display: 'flex'
    }),
    color: theme.vars.palette.text.primary,
    ...(disabled && {
      pointerEvents: 'none'
    })
  }), ...(Array.isArray(sx) ? sx : [sx])]} {...other}>
      {dinamic && photoURL ? <Avatar src={photoURL} sx={{
      width: 45,
      height: 45
    }} /> : <>
          <Box component="img" src={`${CONFIG.assetsDir}/logo/vector-single.svg`} sx={{
        width: 1,
        height: 1
      }} />
          {isFull && 'estore'}
        </>}
    </Box>;
}